var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"el-icon-refresh cursor-pointer",on:{"click":function($event){return _vm.$emit('c-click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }